import { render, staticRenderFns } from "./MultiPolMtrRiskHelpList.vue?vue&type=template&id=a8e4f2dc&"
import script from "./MultiPolMtrRiskHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiPolMtrRiskHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports